import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { QA_NAME_ICON_DEFAULT } from '../../../constants/qa'
import { getQaSelector } from '../../../utils/common'
import Button from '../../Button'

function TableControlIcon({
  Icon,
  disabled,
  isGrey = true,
  qaName,
  onClick,
  ...restProps
}) {
  function handleClick() {
    if (!disabled) {
      onClick?.()
    }
  }

  const qaProps = getQaSelector({
    context: QA_NAME_ICON_DEFAULT,
    value: qaName,
  })

  return (
    <Button.Icon
      {...restProps}
      Icon={Icon}
      dataProps={qaProps}
      disabled={disabled}
      isGrey={isGrey}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
      onClick={handleClick}
    />
  )
}

export default TableControlIcon
